function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useMemo, useState } from 'react';
import { DesktopControls } from 'app/components/tv/customControls/DesktopControls';
import { MobileControls } from 'app/components/tv/customControls/MobileControls';
import styled from 'styled-components';
import { trackVideoProgress } from 'app/components/tv/helpers/trackVideoProgress';
const Wrapper = styled.div.withConfig({
  componentId: "sc-183kslr-0"
})(["display:", ";"], props => props.show ? 'block' : 'none');
const skipTime = 10;
const skipForward = player => {
  const currentVideoTime = player.currentTime();
  let newTime;
  if (currentVideoTime + skipTime <= player.duration()) {
    newTime = currentVideoTime + skipTime;
  } else {
    newTime = player.duration();
  }
  player.currentTime(newTime);
};
const skipBackwards = player => {
  const currentVideoTime = player.currentTime();
  let newTime;
  if (currentVideoTime >= skipTime) {
    newTime = currentVideoTime - skipTime;
  } else {
    newTime = 0;
  }
  player.currentTime(newTime);
};
export const CustomControls = _ref => {
  let {
    show,
    playlist,
    playlistPlugin,
    video,
    playerRef,
    playerReady,
    isMobile,
    playlistFinished,
    currentVideoIndex,
    videoContainerRef,
    ...props
  } = _ref;
  const [hideDesktop, setHideDesktop] = useState(false);
  const isSeekable = useMemo(() => video.isSeekable(), [video]);
  useEffect(() => setHideDesktop(isMobile), [isMobile]);
  const handlePreviousVideo = () => {
    const player = playerRef.current;
    if (!player) {
      return;
    }
    if (isSeekable) {
      skipBackwards(player);
    } else {
      trackVideoProgress(video, player.played());
      const isLoaded = playlistPlugin.loadPreviousItem();
      if (!isLoaded) {
        player.currentTime(video.startTime);
      }
    }
  };
  const handleNextVideo = () => {
    const player = playerRef.current;
    if (!player) {
      return;
    }
    if (isSeekable) {
      skipForward(player);
    } else {
      trackVideoProgress(video, player.played());
      const isLoaded = playlistPlugin.loadNextItem();
      if (!isLoaded) {
        var _video$videoDuration;
        const finalSec = video.startTime + ((_video$videoDuration = video.videoDuration) !== null && _video$videoDuration !== void 0 ? _video$videoDuration : 45);
        player.currentTime(finalSec);
      }
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    show: show,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CustomControls",
    "data-sentry-source-file": "CustomControls.tsx"
  }, /*#__PURE__*/React.createElement(MobileControls, _extends({
    handlePreviousVideo: handlePreviousVideo,
    handleNextVideo: handleNextVideo,
    playerRef: playerRef,
    playerReady: playerReady,
    hide: !hideDesktop || playlistFinished,
    isSeekable: isSeekable
  }, props, {
    "data-sentry-element": "MobileControls",
    "data-sentry-source-file": "CustomControls.tsx"
  })), /*#__PURE__*/React.createElement(DesktopControls, _extends({
    handlePreviousVideo: handlePreviousVideo,
    handleNextVideo: handleNextVideo,
    playlist: playlist,
    playerRef: playerRef,
    playerReady: playerReady,
    videoContainerRef: videoContainerRef,
    currentVideoIndex: currentVideoIndex,
    hide: hideDesktop || playlistFinished,
    isSeekable: isSeekable
  }, props, {
    "data-sentry-element": "DesktopControls",
    "data-sentry-source-file": "CustomControls.tsx"
  })));
};